export default __webpack_public_path__ + "static/media/twoHands.584a28ef.png";